import { useContext } from 'react';
import { ReflectionsContext } from '../components/context/reflections-context';
export const useReflections = () => (useContext(ReflectionsContext) || []);
